export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "ar-AE": {
        "delete": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["حذف"])}
        },
        "keep": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["لتحفظ"])}
        }
      },
      "ar-EG": {
        "delete": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["حذف"])}
        },
        "keep": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["لتحفظ"])}
        }
      },
      "ar-SA": {
        "delete": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["حذف"])}
        },
        "keep": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["لتحفظ"])}
        }
      },
      "el-GR": {
        "delete": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Διαγράφω"])}
        },
        "keep": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Κρατώ"])}
        }
      },
      "el-CY": {
        "delete": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Διαγράφω"])}
        },
        "keep": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Κρατώ"])}
        }
      },
      "de-DE": {
        "delete": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Löschen"])}
        },
        "keep": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Behalten"])}
        }
      },
      "de-AT": {
        "delete": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Löschen"])}
        },
        "keep": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Behalten"])}
        }
      },
      "de-CH": {
        "delete": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Löschen"])}
        },
        "keep": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Behalten"])}
        }
      },
      "en-US": {
        "delete": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Delete"])}
        },
        "keep": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Keep"])}
        }
      },
      "en-GB": {
        "delete": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Delete"])}
        },
        "keep": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Keep"])}
        }
      },
      "it-IT": {
        "delete": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Elimina"])}
        },
        "keep": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mantenere"])}
        }
      },
      "fr-FR": {
        "delete": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Effacer"])}
        },
        "keep": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Garder"])}
        }
      },
      "es-ES": {
        "delete": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Eliminar"])}
        },
        "keep": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mantener"])}
        }
      },
      "pl-PL": {
        "delete": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Usunąć"])}
        },
        "keep": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zachować"])}
        }
      },
      "nl-NL": {
        "delete": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Verwijderen"])}
        },
        "keep": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Houden"])}
        }
      },
      "bg-BG": {
        "delete": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Изтрий"])}
        },
        "keep": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Да запазя"])}
        }
      },
      "bs-BA": {
        "delete": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Izbriši"])}
        },
        "keep": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zadržati"])}
        }
      },
      "da-DK": {
        "delete": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Slet"])}
        },
        "keep": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["At beholde"])}
        }
      },
      "et-EE": {
        "delete": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kustuta"])}
        },
        "keep": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pidama"])}
        }
      },
      "fi-FI": {
        "delete": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Poistaa"])}
        },
        "keep": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pitää"])}
        }
      },
      "he-IL": {
        "delete": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["לִמְחוֹק"])}
        },
        "keep": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["לשמור"])}
        }
      },
      "ga-IE": {
        "delete": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Scrios"])}
        },
        "keep": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["A choimeád"])}
        }
      },
      "ja-JP": {
        "delete": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["削除"])}
        },
        "keep": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["保つ"])}
        }
      },
      "hr-HR": {
        "delete": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Izbrisati"])}
        },
        "keep": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zadržati"])}
        }
      },
      "lv-LV": {
        "delete": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dzēst"])}
        },
        "keep": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Paturēt"])}
        }
      },
      "lt-LT": {
        "delete": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ištrinti"])}
        },
        "keep": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pasilikti"])}
        }
      },
      "pt-PT": {
        "delete": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Excluir"])}
        },
        "keep": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Manter"])}
        }
      },
      "ro-RO": {
        "delete": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Șterge"])}
        },
        "keep": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Păstra"])}
        }
      },
      "ru-RU": {
        "delete": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Удаление"])}
        },
        "keep": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Хранить"])}
        }
      },
      "sv-SE": {
        "delete": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Radera"])}
        },
        "keep": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Behålla"])}
        }
      },
      "sk-SK": {
        "delete": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Odstrániť"])}
        },
        "keep": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Udržať"])}
        }
      },
      "cs-CZ": {
        "delete": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vymazat"])}
        },
        "keep": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zachovat"])}
        }
      },
      "hu-HU": {
        "delete": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Töröl"])}
        },
        "keep": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tartani"])}
        }
      },
      "fr-BE": {
        "delete": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Effacer"])}
        },
        "keep": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Garder"])}
        }
      },
      "fr-LU": {
        "delete": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Effacer"])}
        },
        "keep": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Garder"])}
        }
      },
      "mt-MT": {
        "delete": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ħassar"])}
        },
        "keep": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "sl-SI": {
        "delete": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Izbriši"])}
        },
        "keep": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Obdržati"])}
        }
      },
      "tr-TR": {
        "delete": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sil"])}
        },
        "keep": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Saklamak"])}
        }
      },
      "tr-CY": {
        "delete": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sil"])}
        },
        "keep": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Saklamak"])}
        }
      },
      "uk-UA": {
        "delete": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Löschen"])}
        },
        "keep": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Тримати"])}
        }
      },
      "zh-CN": {
        "delete": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["删除"])}
        },
        "keep": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["保持"])}
        }
      }
    }
  })
}
